export { MatchmakerIcon } from '../src/MatchmakerIcon';
